import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";

type SearchBarProps = {
  onSearch: (value: string) => void;
  className?: string;
  inputClassName?: string;
  buttonClassName?: string;
  placeholder?: string;
  value?: string;
  borderWidthClass?: string;
  borderClass?: string;
  iconClass?: string;
  disabled?: boolean;
  iconVariant?: "fa" | "fi";
};

const SearchBar : React.FC<SearchBarProps> = ({
  onSearch,
  className = "",
  inputClassName = "",
  buttonClassName = "",
  placeholder = "Digite o que você procura...",
  value,
  borderWidthClass = "border-2",
  borderClass = "border-primary-600",
  iconClass = "text-primary-600",
  disabled = false,
  iconVariant = "fa"
}) => {
  const [internalValue, setInternalValue] = useState(value ?? "");
  const resolvedPlaceholder = placeholder === "Digite o que você procura..."
    ? "Digite o que você procura..."
    : placeholder;

  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch(internalValue);
    }
  };

  const handleClick = () => {
    onSearch(internalValue);
  };

  return (
    <div
      className={`flex items-center bg-white rounded ${borderWidthClass} ${borderClass} text-black overflow-hidden ${
        disabled ? "opacity-60 cursor-not-allowed" : ""
      }`}
    >
      <input
        type="text"
        placeholder={resolvedPlaceholder}
        value={internalValue}
        disabled={disabled}
        onChange={(e) => {
          const next = e.target.value;
          setInternalValue(next);
          onSearch(next);
        }}
        onKeyDown={handleKeyPress}
        className={`pl-2 py-2 text-xs outline-none ${className} sm:pl-4 sm:text-sm ${inputClassName}`}
      />
      <button 
        className={`px-2 sm:px-4 transition-opacity hover:opacity-70 disabled:hover:opacity-100 ${iconClass} ${buttonClassName}`}
        onClick={handleClick}
        disabled={disabled}
      >
        {iconVariant === "fi" ? <FiSearch /> : <FaSearch />}
      </button>         
    </div>
  );
};

export default SearchBar;
